import {AnticipatedDischargesFilterValue} from "./domain";
import {MultiFilterButton, SimpleDropdown} from "common";
import React, {Dispatch, useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import {DatePickerInput} from "../../../common/component/DatePickerInput";
import {AnticipatedDischargePageAction} from "./AnticipatedDischargePage";

type AnticipatedDischargesFilterProps = {
    initFilterValue: AnticipatedDischargesFilterValue;
    dispatch: Dispatch<AnticipatedDischargePageAction>
}
const statusMap = new Map<string, string>([
    ['', 'All'],
    ['Open', 'Open'],
    ['Confirmed', 'Confirmed']
]);

const AnticipatedDischargeFilter = ({initFilterValue, dispatch}: AnticipatedDischargesFilterProps) => {
    const [filterValue, setFilterValue] = useState({...initFilterValue});
    useEffect(() => {
        setFilterValue(initFilterValue);
    }, [initFilterValue])
    const onFilterUpdate = (fieldName: string, fieldValue: any) => {
        setFilterValue({...filterValue, [fieldName]: fieldValue})
    }

    return (
        <MultiFilterButton<AnticipatedDischargesFilterValue>
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            emptyFilterValue={{
                anticipatedDischargeDateFrom: null,
                anticipatedDischargeDateTo: null,
                dischargeNotificationDateFrom: null,
                dischargeNotificationDateTo: null,
                clientName: '',
                status: ''
            }}
            dispatchSetFilterValue={(val) => dispatch({type: "SET_FILTER", filter: val})}
            filterOptions={[
                {
                    label: "Status",
                    component: <SimpleDropdown
                        options={statusMap}
                        minWidth={"10rem"}
                        textColor={"gray-600"}
                        selected={filterValue.status}
                        setSelected={(selected) => onFilterUpdate("status", selected)}
                    />
                },
                {
                    label: "Anticipated Discharge From",
                    component: <DatePicker
                        wrapperClassName="w-full"
                        selected={filterValue.anticipatedDischargeDateFrom || null}
                        onSelect={(newValue: Date | null) => onFilterUpdate("anticipatedDischargeDateFrom", newValue)}
                        onChange={() => {}}
                        customInput={<DatePickerInput
                            fieldName="anticipatedDischargeDateFrom"
                            value={undefined}
                            onFinish={(newValue: Date | null) => onFilterUpdate("anticipatedDischargeDateFrom", newValue)}
                        />}
                    />
                },
                {
                    label: "Anticipated Discharge To",
                    component: <DatePicker
                        wrapperClassName="w-full"
                        selected={filterValue.anticipatedDischargeDateTo || null}
                        onSelect={(newValue: Date | null) => onFilterUpdate("anticipatedDischargeDateTo", newValue)}
                        onChange={() => {}}
                        customInput={<DatePickerInput
                            fieldName="anticipatedDischargeDateTo"
                            value={undefined}
                            onFinish={(newValue: Date | null) => onFilterUpdate("anticipatedDischargeDateTo", newValue)}
                        />}
                    />
                },
                {
                    label: "Discharge Notification From",
                    component: <DatePicker
                        wrapperClassName="w-full"
                        selected={filterValue.dischargeNotificationDateFrom || null}
                        onSelect={(newValue: Date | null) => onFilterUpdate("dischargeNotificationDateFrom", newValue)}
                        onChange={() => {}}
                        customInput={<DatePickerInput
                            fieldName="dischargeNotificationDateFrom"
                            value={undefined}
                            onFinish={(newValue: Date | null) => onFilterUpdate("dischargeNotificationDateFrom", newValue)}
                        />}
                    />
                },
                {
                    label: "Discharge Notification To",
                    component: <DatePicker
                        wrapperClassName="w-full"
                        selected={filterValue.dischargeNotificationDateTo || null}
                        onSelect={(newValue: Date | null) => onFilterUpdate("dischargeNotificationDateTo", newValue)}
                        onChange={() => {}}
                        customInput={<DatePickerInput
                            fieldName="dischargeNotificationDateTo"
                            value={undefined}
                            onFinish={(newValue: Date | null) => onFilterUpdate("dischargeNotificationDateTo", newValue)}
                        />}
                    />
                },
            ]}
        />
    )
}
export default AnticipatedDischargeFilter;